import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditingForm,
  setEditingForm,
  setEditingQuestionId,
} from "../../redux/features/appData/appDataSlice";
import "./FormResponsesMenu.css";
import "../../css/Icons.css";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import { apiCreateQuestionForForm, apiDeleteQuestion, apiUpdateQuestionConditions } from "../../services/QuestionService";
import { CreateQuestionForFormPayload, Question, UpdateFormQuestionOrderPayload, UpdateQuestionConditionsPayload } from "effno-core";
import { apiUpdateFormQuestionOrder } from "../../services/FormService";
import { addNewQuestionToOrder } from "../shared/uiHelpers";
import { Condition } from "../workflow/questionWorkflowConditions";

const RESPONSES_MENU = {
  HIDE: "hide",
  HIDE_MODAL: "hide_modal",
};

type FormResponsesMenuProps = {
    questionId: string;
    onHide: (formResponseId: string) => void;
    onTableSettings: () => void;
};

export default function FormResponsesMenu({ questionId, onHide, onTableSettings }: FormResponsesMenuProps) {

  const [anchorEl, setAnchorEl] = useState(null);

//   const [showTableSettings, setShowTableSettings] = useState<boolean>(false);

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case RESPONSES_MENU.HIDE:
        onHide(questionId);
        break;
      case RESPONSES_MENU.HIDE_MODAL:
        onTableSettings();
        break; 
      default:
    }
  };

  return (
    <>
      <div className="form-responses-menu" onClick={handleButtonClick}>
        <div className="form-responses-image">
          <img className="icon-three-dots-vertical" alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        
        <MenuItem 
          onClick={(e: any) => {
            e.stopPropagation();
            handleMenuSelection(RESPONSES_MENU.HIDE)
          }}
        >
            Hide Question
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(RESPONSES_MENU.HIDE_MODAL)}>
            Display Settings
        </MenuItem>
        
      </Menu>
    </>
  );
}
